import React from 'react';

import {
  SalesFooter
} from 'src/Common/constants';

import './Footer.css';

function Footer() {
  const renderCards = () => {

    return SalesFooter.map((item, index) => (

      <div key={ index } className="footer-card">

        <div className="footer-icon">{ item.icon }</div>

        <div>
          <p className="footer-step">Step { item.step }</p>
          <h3 className="footer-heading">{ item.heading }</h3>
          <p className="footer-description">{ item.description }</p>

          { item.hasVideo && (
            <a
              className="fibre-footer-link"
              href="https://www.vodacom.co.za/sites/vodacomcoza/files/2023-11/how-to-connect-your-fibre-devices.mp4"
              target="_blank"
              rel="noopener noreferrer"
            >
                Watch now
            </a>
          )
          }
        </div>
      </div>
    ));
  };

  return (

    <div className="footer-container">

      <div className="footer-text-container">
        <h3 className="footer-container-text">What happens</h3>
        <h3 className="footer-container-sub-text">after I order Fibre?</h3>
      </div>

      <div className="footer-card-container">{ renderCards() }</div>
    </div>
  );
}

export default Footer;
